export function getKeyboardInset(): number {
  const viewport = window.visualViewport;

  if (!viewport) {
    return 0;
  }

  return Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
}
